import React from "react";
import {
  ChartBar,
  CurrencyBtc,
  Trophy,
  Bank,
  Globe,
  Cpu,
  Confetti,
  IdentificationCard,
  Crown,
  Robot,
  ListBullets,
} from "@phosphor-icons/react";

const ICONS = {
  politics: IdentificationCard,
  crypto: CurrencyBtc,
  sports: Trophy,
  economy: Bank,
  geopolitics: Globe,
  tech: Cpu,
  "pop-culture": Confetti,
  elections: ChartBar,
  trump: Crown,
  ai: Robot,
};

const ORDERS = [
  { value: "volumeNum", label: "Volume" },
  { value: "liquidityNum", label: "Liquidity" },
  { value: "endDate", label: "Ending Soon", asc: true },
  { value: "startDate", label: "Newest" },
];

export default function Sidebar({
  categories = [],
  activeCategory,
  setCategory,
  order,
  setOrder,
  ascending,
  setAscending,
}) {
  return (
    <aside
      data-testid="sidebar"
      className="hidden lg:block w-60 shrink-0 border-r border-white/10 sticky top-16 self-start h-[calc(100vh-4rem)] overflow-y-auto"
    >
      <div className="p-5 border-b border-white/10">
        <div className="text-[10px] uppercase tracking-[0.25em] font-mono text-zinc-500 mb-3">
          Sort
        </div>
        <div className="flex flex-col gap-1">
          {ORDERS.map((o) => (
            <button
              key={o.value}
              data-testid={`sort-${o.value}`}
              onClick={() => {
                setOrder(o.value);
                setAscending(!!o.asc);
              }}
              className={`text-left text-sm font-body px-2 py-1.5 border-l-2 transition-colors ${
                order === o.value
                  ? "border-edge text-white bg-white/5"
                  : "border-transparent text-zinc-400 hover:text-white hover:border-white/30"
              }`}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>

      <div className="p-5">
        <div className="text-[10px] uppercase tracking-[0.25em] font-mono text-zinc-500 mb-3">
          Categories
        </div>
        <div className="flex flex-col gap-1">
          <button
            data-testid="cat-all"
            onClick={() => setCategory(null)}
            className={`flex items-center gap-2 text-left text-sm font-body px-2 py-1.5 border-l-2 transition-colors ${
              !activeCategory
                ? "border-edge text-white bg-white/5"
                : "border-transparent text-zinc-400 hover:text-white hover:border-white/30"
            }`}
          >
            <ListBullets size={16} weight="duotone" />
            All Markets
          </button>
          {categories.map((c) => {
            const Icon = ICONS[c.slug] || ListBullets;
            const active = activeCategory === c.slug;
            return (
              <button
                key={c.slug}
                data-testid={`cat-${c.slug}`}
                onClick={() => setCategory(c.slug)}
                className={`flex items-center gap-2 text-left text-sm font-body px-2 py-1.5 border-l-2 transition-colors ${
                  active
                    ? "border-edge text-white bg-white/5"
                    : "border-transparent text-zinc-400 hover:text-white hover:border-white/30"
                }`}
              >
                <Icon size={16} weight="duotone" />
                {c.label}
              </button>
            );
          })}
        </div>
      </div>
    </aside>
  );
}
